<template>
    <BaseSection
        v-if="hasContact"
        class="event-contact"
    >
        <h4 class="event-contact__title">Contact our organiser</h4>
        <p>{{ event.organiser }}</p>
        <p v-if="event.email || event.website">
            <template v-if="event.email">
                <strong>Email:</strong>&nbsp;
                <a :href="`mailto:${event.email}`">{{ event.email }}</a>
            </template>

            <br v-if="event.email && event.phone">

            <template v-if="event.phone">
                <strong>Phone:</strong>&nbsp;
                <a :href="`tel:${event.phone}`">{{ event.phone }}</a>
            </template>
        </p>
    </BaseSection>
</template>

<script>
export default {
    props: {
        event: {
            type: Object,
            required: true,
            default: null
        }
    },

    computed: {
        hasContact() {
            return !!this.event.email?.length || !!this.event.phone?.length;
        }
    }
};
</script>

<style lang="less">
.event-contact {
    p {
        font-size: var(--font-size-sm);
        margin-top: 1rem;
    }
}

.event-contact__title {
    .typography-label-secondary;

    & + p {
        margin-top: 0;
    }
}
</style>
